import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { TrackingCaseDocumentListViewTemplate } from "themes/application/tracking-case/pages";
import { TrackingCaseDocumentListViewStore } from "application/tracking-case/stores";

@setCurrentView((rootStore) => new TrackingCaseDocumentListViewStore(rootStore), "trackingCaseDocumentListViewStore")
@observer
class TrackingCaseDocumentListView extends React.Component {
    render() {
        return <TrackingCaseDocumentListViewTemplate {...this.props} />;
    }
}

export default TrackingCaseDocumentListView;